import type { ApiClient } from '@travel/api-client';

import { MONTEROSA_API_TIMEOUT } from 'store/utils';

import type { PlanList, RequestBody } from 'PlanList-Types';
export const fetchPlanList = (
  http: ApiClient,
  query: RequestBody,
  ipAddress?: string,
): Promise<PlanList> => {
  const headers = ipAddress ? { 'trv-client-ip': ipAddress } : undefined;

  return http.post(`/monterosa-api-dp/dp/jrdp/plan-item-summaries`, {
    values: query,
    timeout: MONTEROSA_API_TIMEOUT,
    headers,
  });
};
